import { render, staticRenderFns } from "./CategoryGoodsTemplate.vue?vue&type=template&id=1438c37d&"
import script from "./CategoryGoodsTemplate.vue?vue&type=script&lang=js&"
export * from "./CategoryGoodsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports